import { AnimatePresence, motion } from "framer-motion";
import { useRef, useState } from "react";
import styled from "styled-components";
import { useMouseOver } from "../lib/hooks/useMouseOver";
import { InteractionArtifact } from "../models/client";
import { fill } from "../styles/utils";
import { CursorHolder } from "./CursorHolder";
import { LongCursor } from "./cursors/LongCursor";
import { InteractionTransition } from "./InteractionTransition";

interface InteractionProps {
  artifact: InteractionArtifact;
}

const Boundary = styled(motion.div)`
  ${fill()}
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  flex-direction: column;
  cursor: none;
`;

const Container = styled.div`
  position: relative;
  max-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 100%;
`;
const HiddenImage = styled.img`
  position: relative;
  max-height: 100%;
  width: auto;
  max-width: 100%;
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
  pointer-events: none;
`;

export const Interaction: React.FC<InteractionProps> = ({ artifact }) => {
  const [isAnimating, setIsAnimating] = useState(false);
  const [selected, setSelected] = useState(false);

  const hoverRef = useRef(null);
  const isHovered = useMouseOver(hoverRef);

  return (
    <>
      <Boundary ref={hoverRef} onTap={() => setSelected(!selected)}>
        <AnimatePresence>
          {!selected && isHovered && !isAnimating && (
            <CursorHolder visible={isHovered}>
              <LongCursor icon="reply">Look inside</LongCursor>
            </CursorHolder>
          )}
        </AnimatePresence>
        <AnimatePresence>
          {selected && isHovered && !isAnimating && (
            <CursorHolder visible={isHovered}>
              <LongCursor icon="reply">Back</LongCursor>
            </CursorHolder>
          )}
        </AnimatePresence>
        <Container>
          <HiddenImage src={artifact.imgStart.src}></HiddenImage>

          <InteractionTransition
            imgStart={artifact.imgStart}
            imgEnd={artifact.imgEnd}
            selected={selected}
            onAnimationStart={() => setIsAnimating(true)}
            onAnimationEnd={() => setIsAnimating(false)}
          ></InteractionTransition>
        </Container>
      </Boundary>
    </>
  );
};
